import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[groupColumnHeaderTemplate]',
})
export class GroupColumnHeaderTemplateDirective {
  @Input()
  field!: string;
  constructor(public template: TemplateRef<any>) {}
}
